import { Helmet } from 'react-helmet'

import type { Theme } from '../../types/common'
import type { CasinoCategory } from '../../types/game'

interface GameCategoryIconProps extends CasinoCategory {
  isActive: boolean
  size?: number
  className?: string
  theme: Theme
}

const GameCategoryIcon = (props: GameCategoryIconProps) => {
  const {
    size = 40,
    isActive = false,
    theme,
    icon_active,
    icon_off,
    icon_light,
  } = props

  return (
    <div
      style={{
        width: size,
      }}>
      <Helmet>
        <link rel="preload" as="image" href={icon_active} />
        <link rel="preload" as="image" href={icon_off} />
        <link rel="preload" as="image" href={icon_light} />
      </Helmet>
      {isActive ? (
        <img src={icon_active} className="w-full h-[35px] object-contain" />
      ) : (
        <img
          src={theme === 'light' ? icon_light : icon_off}
          className="w-full h-[35px] object-contain"
        />
      )}
    </div>
  )
}

export default GameCategoryIcon
